import React, { useEffect, useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Grid,
    Divider,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import closeIcon from "../../assets/icons/close.png";
import { ThreeDot } from "react-loading-indicators";
import { getAssociatedRfqsApi, getKamProfilePicApi } from "../Services/OrgRepo";
import { generatProfilePicUrl } from "../../Utils/Constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";

const getCurrencyIcon = (currency) => {
    switch (currency) {
        case "INR":
            return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
        case "USD":
            return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
        case "EUR":
            return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
        default:
            return null;
    }
};

const AssociatedRFQsDrawer = ({ open, onClose, selectedPartner, value }) => {
    const [loading, setLoading] = useState(false);
    const [associatedRfq, setAssociatedRfq] = useState(null);
    const [profileImage, setProfileImage] = useState("");

    const getAssociatedRfqData = async () => {
        setLoading(true);
        try {
            const data = await getAssociatedRfqsApi(
                value === "1"
                    ? selectedPartner?.organisationName
                    : selectedPartner?.companyName,
                value === "1" ? "Organisation_name" : "Company_Name"
            );
            if (data?.status) {
                setAssociatedRfq(data?.data);
            } else {
                setAssociatedRfq([]);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setAssociatedRfq([]);
            console.log("Error while fetching getCompanyData");
        }
    };

    const getProfilePic = async () => {
        setProfileImage("");
        try {
            const data = await getKamProfilePicApi(selectedPartner?.KAMId);
            if (data?.status) {
                const img = generatProfilePicUrl(
                    selectedPartner?.KAMId,
                    data?.data,
                    "Profile_Picture"
                );
                setProfileImage(img);
            } else {
                setProfileImage("");
            }
            setLoading(false);
        } catch (err) {
            setProfileImage("");
            console.log("Error while fetching getCompanyData");
        }
    };

    useEffect(() => {
        if (selectedPartner?.organisationName) {
            getAssociatedRfqData();
            setProfileImage("");
        }
        if (selectedPartner?.KAMId) {
            getProfilePic();
        }
    }, [selectedPartner]);

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Associated Company RFQs
                    </Typography>
                    <Box>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={closeIcon} width={14} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{ my: 2 }} />

                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                {value === "1"
                                    ? "Organisation ID"
                                    : "Company ID"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2">
                                {selectedPartner?.orgID
                                    ? selectedPartner?.orgID
                                    : selectedPartner?.companyID}
                                {/* {"P01" || "N/A"} */}
                            </Typography>
                        </Grid>
                        {selectedPartner?.keyAccoutantManager && (
                            <>
                                <Grid item xs={12} md={5}>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Key Account Manager
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    <Typography
                                        variant="body2"
                                        display="flex"
                                        alignItems="center"
                                    >
                                        {profileImage && (
                                            <img
                                                src={profileImage}
                                                width={24}
                                                height={24}
                                                style={{
                                                    marginRight: "5px",
                                                    borderRadius: "50%"
                                                }}
                                                alt="KAM"
                                            />
                                        )}
                                        {selectedPartner?.keyAccountManager
                                            ? selectedPartner?.keyAccountManager
                                            : selectedPartner?.keyAccoutantManager}
                                    </Typography>
                                </Grid>
                            </>
                        )}

                        {/* <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Last Updated
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant="body2">
                {selectedPartner?.lastUpdatedTime}
                {/* {"P01" || "N/A"}
              </Typography>
            </Grid> */}
                        {/* 
            <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Status
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              {selectedPartner?.status == "Active" ? (
                <Chip
                  label={"Active"}
                  color="success"
                  variant="outlined"
                  size="small"
                />
              ) : (
                <Chip
                  label={"InActive"}
                  variant="outlined"
                  size="small"
                  sx={{
                    border: "1px solid #ccc",
                    color: "#797979",
                  }}
                />
              )}
            </Grid> */}
                    </Grid>
                    <Divider sx={{ my: 2 }} />
                    {!loading ? (
                        associatedRfq?.length > 0 ? (
                            <>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                    sx={{ mb: 1 }}
                                >
                                    Associated CORFQs
                                </Typography>

                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        maxHeight: 400,
                                        overflowX: "auto",
                                        boxShadow: "none!important",
                                        border: "1px solid #F2F2F2"
                                    }}
                                >
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor:
                                                            "#E3E8EF"
                                                    }}
                                                >
                                                    CORFQ ID
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor:
                                                            "#E3E8EF"
                                                    }}
                                                >
                                                    CORFQ name
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        backgroundColor:
                                                            "#E3E8EF"
                                                    }}
                                                >
                                                    Total Order value
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {associatedRfq?.map(
                                                (row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {row?.rfqID}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row?.rfqName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {/* {row?.Company_Name} */}

                                                            {getCurrencyIcon(
                                                                row?.currency
                                                            )}
                                                            {row?.totalOrderValue !==
                                                                undefined &&
                                                            row?.totalOrderValue !==
                                                                null
                                                                ? new Intl.NumberFormat(
                                                                      "en-IN"
                                                                  ).format(
                                                                      Number(
                                                                          row.totalOrderValue
                                                                      )
                                                                  )
                                                                : "-"}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        ) : (
                            "No Data found"
                        )
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh" // Ensures it takes up the full height of the viewport
                            }}
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </Drawer>
    );
};

export default AssociatedRFQsDrawer;
